import classNames from 'classnames';
import React, { FC } from 'react';

import './ActionBar.scss';

interface IProps {
  flex?: boolean;
  center?: boolean;
  hasChanges?: boolean;
}

const ActionBar: FC<IProps> = ({ children, flex, center, hasChanges }) => {
  return (
    <div className={classNames('ActionBar')}>
      <div
        className={classNames({
          'ActionBar-flex': flex,
          'ActionBar-center': center,
        })}
      >
        {children}
      </div>
      {hasChanges && <div className="badge bg-warning text-dark">Has changes</div>}
    </div>
  );
};

export default ActionBar;
